import { css } from '@emotion/react';
import { useTheme } from '@mui/material';
import {
  UICoreColor,
  UICoreSize,
  UICoreSpacing,
} from '@shared/react-ui-core/theme';

const useStyle = () => {
  const theme = useTheme();
  const { spacing } = theme;
  const { md, lg } = theme.breakpoints.values;

  const container = css`
    --container-bg: transparent;
    --container-max-width: ${UICoreSize.wide};
    --container-padding-x: ${spacing(UICoreSpacing.px25)};
    --container-padding-y: ${spacing(UICoreSpacing.px50)};

    @media (min-width: ${md}px) {
      --container-padding-x: ${spacing(UICoreSpacing.px50)};
    }

    @media (min-width: ${lg}px) {
      --container-padding-x: ${spacing(UICoreSpacing.px100)};
      --container-padding-y: ${spacing(UICoreSpacing.px75)};
    }

    background-color: var(--container-bg);
    max-width: var(--container-max-width);
    padding: var(--container-padding-y) var(--container-padding-x);
    color: var(--container-color, ${UICoreColor.text});

    margin: 0 auto;
  `;

  const setBg = (bg: UICoreColor) =>
    css`
      --container-bg: ${UICoreColor[bg]};
    `;

  const setWidth = (width: UICoreSize) => css`
    --container-max-width: ${UICoreSize[width]};
  `;

  const setNoPadding = (noPadding: boolean = false) => css`
    ${noPadding &&
    css`
      --container-padding-x: 0 !important;
      --container-padding-y: 0 !important;
    `}
  `;

  const setColor = (color: UICoreColor) => css`
    --container-color: ${UICoreColor[color]};
  `;

  return { container, setBg, setWidth, setNoPadding, setColor };
};

export default useStyle;
